var LaravelElixirBundle = (function (exports) {
'use strict';

$(document).ready(function(){
    $('.downarrow').on('click', function(){
        var card = $(this).parent('.review-card');
        var regCardContent = $(this).siblings('.card-content');
        var expCardContent = $(this).siblings('.expanded-card-content');
        var arrow = $(this);
        var brand = regCardContent.children("img").attr("alt");

        if(arrow.hasClass('arrow-rotate')){
            TagManager.fireEvent('cardclosed' , {"cardbrand":brand});
            showRegular(expCardContent, regCardContent, card, arrow);
        } else {
            TagManager.fireEvent('cardopened' , {"cardbrand":brand});
            showExpanded(expCardContent,regCardContent, card, arrow);
        }
    });

    $('.downarrow').hover(
    function() {
        $(this).addClass('red');
     }, function() {
         $(this).removeClass('red');
    });
});

function showExpanded(expanded,regular,card, arrow){
    arrow.removeClass('red');
    expanded.css("max-height",expanded[0].scrollHeight);
    widenCard(expanded, regular, card, arrow);
}

function showRegular(expanded, regular, card, arrow){
    arrow.removeClass('red');
    expanded.css("max-height","0px");
    shrinkCard(expanded, regular, card, arrow);
}

function widenCard(expanded, regular, card, arrow){
    card.animate({
        marginLeft:'1em',
        marginRight:'1em',
        paddingLeft:'1.5em',
        paddingRight:'1.5em',
    },200,function(){
            arrow.addClass('arrow-rotate');
        });
}

function shrinkCard(expanded, regular, card, arrow){
    card.animate({
        marginLeft:'1.5em',
        marginRight:'1.5em',
        paddingLeft:'1em',
        paddingRight:'1em',
    },200,function(){
            arrow.removeClass('arrow-rotate');
        });
}

return exports;

}({}));
//# sourceMappingURL=animate-review-listB.js.map
